import { Component } from 'react';
import classNames from 'classnames';
import styles from './styles/CurationTool.module.scss';
import FlatIcon from "../../../utilities/FlatIcon";
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Button from "../../../utilities/Button";
import {StoreContext} from "../../../../stores/StoreLoader";

@observer
export default class CurationTool extends Component {
    static contextType = StoreContext;
    static propTypes = {
        id: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        handleViewClick: PropTypes.func,
        style: PropTypes.object,
    };

    static defaultProps = {
        style: {},
    };

    toggleHidden = (id, state) => {
        this.context.organizationStore.updateContentItem(this.props.type, id, {'user_published': state});
    };

    deleteContentItem = id => {
        this.context.organizationStore.deleteContentItem(id, this.props.type);
    };

    handleView = () => {
        if (this.props.type === 'news' || this.props.type === 'events') {
            this.props.handleViewClick(false);
        } else if (this.props.type === 'gallery') { // pass through click event to gallery item
            this.props.handleViewClick();
        }
    };

    render() {
        const curationContainerClassName = classNames({
            [styles.curationContainer]: true,
            [styles.curationContainerEvents]: this.props.type === 'events',
            [styles.curationContainerNews]: this.props.type === 'news',
            [styles.curationContainerGallery]: this.props.type === 'gallery'
            || this.props.type === 'reviews'
            || this.props.type === 'files_folders',
        });

        const itemObj = this.context.organizationStore.blocks.get(this.props.type).items.find(item => item.id === this.props.id);

        return (
            <div className={curationContainerClassName} style={this.props.style}>
                <div>
                    {this.props.handleViewClick && <Button onClick={this.handleView}>
                        <FlatIcon name={'flaticon-search'}/>
                        View
                    </Button>}
                    {this.props.handleEditClick && <Button onClick={this.props.handleEditClick}>
                        <FlatIcon name={'flaticon-edit'}/>
                        Edit
                    </Button>}
                    {itemObj && itemObj.published ? itemObj.is_custom ? <Button onClick={() => this.deleteContentItem(itemObj.id)}>
                        <FlatIcon name={'flaticon-remove'}/>
                        Delete
                    </Button> :
                        <Button onClick={() => this.toggleHidden(itemObj.id, !itemObj.published)}>
                            <FlatIcon name={'flaticon-hidden'}/>
                            Hide
                        </Button> : (
                        <Button onClick={() => this.toggleHidden(itemObj.id, !itemObj.published)}>
                            <FlatIcon name={'flaticon-eye'}/>
                            Unhide
                        </Button>
                    )}
                </div>
            </div>
        )
    }
}
